import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { first, Observable } from 'rxjs';
import { PITEventService, UtilsMisc } from '@pit/core';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { EntityStoreFacade } from '@pit/core-store';
import { IDtoUser } from '@pit/frontend-model';
import { DtoUserStoreFactory } from './dto.user.store.factory';
import { IDtoUserEntityDataService } from '../../module.data/services/interfaces/dto.user.entity.data.service.interface';

@Injectable({
    providedIn: 'root'
})
export class DtoUserStoreFacade extends EntityStoreFacade<IDtoUser> {

    constructor(store: Store<IDtoUser>, dataServiceAccessor: EntityDataServiceAccessorService, eventService: PITEventService) {
        super(DtoUserStoreFactory.instance, store, 'DtoUser', dataServiceAccessor, eventService);
    }

    public loadWebUsersForMandator$(mandatorId: number): void {
        this.store.dispatch(this.entityStoreFactory.getAction('load.for.web')({ mandatorId: mandatorId }));
    }

    public async loadWebUsersForMandatorAsync(mandatorId: number): Promise<IDtoUser[]> {
        let result: IDtoUser[] = null;
        try {
            const queryResult: IDtoUser[] = await (this.dataServiceAccessor.getEntityDataService<IDtoUser>(this.entityStoreFactory.dataAccessName.toLowerCase()) as IDtoUserEntityDataService).getWebUsersForMandatorAsync(mandatorId);
            if ((UtilsMisc.isNullOrUndefined(queryResult) === false) && (queryResult.length > 0)) {
                result = queryResult;
                this.upsertItemsToStore(result);
            }
        } catch (error) {
        } finally {
        }

        return result;
    }

    public getUsersMobile$(): Observable<IDtoUser[]> {
        return this.store
            .select(this.entityStoreFactory.getSelector('get.users.mobile'));
    }

    public async getUsersMobileAsync(): Promise<IDtoUser[]> {
        let result: IDtoUser[] = null;
        try {
            result = await this.getUsersMobile$().pipe(first()).toPromise();
        } catch {
        }

        return result;
    }

    public getUsersWeb$(): Observable<IDtoUser[]> {
        return this.store
            .select(this.entityStoreFactory.getSelector('get.users.web'));
    }

    public async getUsersWebAsync(): Promise<IDtoUser[]> {
        let result: IDtoUser[] = null;
        try {
            result = await this.getUsersWeb$().pipe(first()).toPromise();
        } catch {
        }

        return result;
    }

    public getUsersWebForUser$(user: IDtoUser): Observable<IDtoUser[]> {
        return this.store
            .select(this.entityStoreFactory.getSelector('get.users.web.for.user')(user));
    }

    public async getUsersWebForUserAsync(user: IDtoUser): Promise<IDtoUser[]> {
        let result: IDtoUser[] = null;
        try {
            result = await this.getUsersWebForUser$(user).pipe(first()).toPromise();
        } catch {
        }

        return result;
    }

}
